import { deletedUsername } from "lib/users/users";
import { QueryResult } from "@apollo/client";
import { logger } from "lib/logger/browser";

import {
  ApiParams,
  getListMyFavoriteDashboardsVariables,
} from "./listMyFavoriteDashboards";

import {
  useListMyFavoriteDashboardsQuery,
  ListMyFavoriteDashboardsQuery,
} from "lib/types/graphql";

import type { Session } from "lib/users/types";

export type HookResult = QueryResult<ListMyFavoriteDashboardsQuery>;

export default function useListMyFavoriteDashboards(
  apiParams: ApiParams,
  session: Session
): HookResult {
  const { owner } = apiParams.filter;
  if (owner && owner.type === "user" && owner.handle === deletedUsername) {
    delete apiParams.filter.owner;
  }

  return useListMyFavoriteDashboardsQuery({
    context: { session }, // Needs session to get private dashboards
    variables: getListMyFavoriteDashboardsVariables(apiParams),
    fetchPolicy: "cache-first",
    onError: logger.error,
  });
}
